import React from 'react';
import { Tabs, Tab } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const AdminProfileAPITabs = ({ selectedTab }) => {
  const navigate = useNavigate();
  const handleTabChange = (event, newValue) => {
    if (newValue === 0) navigate('/admin/profile');
    if (newValue === 1) navigate('/admin/api');
  };
  return (
    <Tabs
      value={selectedTab}
      onChange={handleTabChange}
      centered
      sx={{ mb: 4, '.MuiTabs-indicator': { backgroundColor: 'primary.main', height: 4, borderRadius: 2 }, '.MuiTab-root': { fontWeight: 700, fontSize: 18, color: 'text.secondary', '&.Mui-selected': { color: 'primary.main' } } }}
      aria-label="admin profile/api tabs"
    >
      <Tab label="PROFILE" />
      <Tab label="API" />
    </Tabs>
  );
};

export default AdminProfileAPITabs; 